<template>
  <div>
  <div class="ficher-header-container">
    <v-row class="m-0">
      <v-col class="pl-6 py-3">
        <v-row class="ma-0">
          <div  @click="closeModule" class="fiche-header-back-container">
            <v-row class="pa-1">
              <v-icon  class="back-icon">fas fa-arrow-left</v-icon>
              <div class="ps-2" style="font-size: 12px">Retour</div>
            </v-row>
          </div>

          <div class="pl-4 text-center align-content-center ficher-header-text">{{ title }}</div>

        </v-row>
      </v-col>

<!--      <v-col v-if="!hideChevron" class="text-end col-6">-->
<!--          <v-icon @click='closeAll' class="chevron-icon">fas fa-angles-up</v-icon>-->
<!--          <v-icon  @click='openAll' class="chevron-icon">fas fa-angles-down</v-icon>-->
<!--      </v-col>-->
    </v-row>
  </div>
  </div>
</template>
<script lang="ts">
import { MapRessource } from '@/framework/base/helpers/Ressources';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  props: {
    ressource: {
      type: Object as PropType<MapRessource>
    },
    showExtendButtons: {
      type: Boolean
    },
    hideChevron: {
      type: Boolean
    },
    title: {
      type: String
    }
  },
  computed: {
    titleLabel(): string {
      let res = '';
      if (this.title) {
        res = this.title;
      } else if (this.ressource) {
        res = this.ressource.label;
      }
      return res;
    }
  },
  methods: {
    closeModule() {
      this.$emit('back');
    },
    openAll(): void {
      this.$emit('openAll');
    },
    closeAll(): void {
      this.$emit('closeAll');
    }
  }
})

</script>
